import React, {Component} from 'react';
import {Button, Checkbox, List, Popup} from 'semantic-ui-react';
import {connect} from "react-redux";
import {showToast} from "../../actions/ToastAction";
import {removeCombo} from "../../actions/ComboActions";
import ProductCompoundData from "../../data/ProductCompoundData";

class ProductRecipeItem extends Component {
    constructor(props){
        super(props);
        this.state = {
            quantity: props.quantity,
            can_excluded: props.can_excluded,
            add_loading: false,
            delete_loading: false,
            remove_loading: false,
        }
    }

    handleAdd = () => {
        let quantity = this.state.quantity+1;
        if(quantity >= 1){
            this.setState({add_loading:true});
            this.update({
                id:this.props.id,
                quantity
            });
        }
    };

    handleDelete = () => {
        let quantity = this.state.quantity-1;
        if(quantity >= 1){
            this.setState({delete_loading:true});
            this.update({
                id:this.props.id,
                quantity
            });
        }
    };

    handleRemove = () => {
        this.remove();
    };

    async update(data) {
        ProductCompoundData.update(data, (res) => {
            console.log(res)
            if (res !== null) {
                this.setState({quantity:res.quantity});
            } else {
                this.props.showToast({
                    show:true,
                    type:'error',
                    message:'Tenemos un problema!'
                });
            }
            this.setState({add_loading:false, delete_loading:false});
        });
    };

    async remove() {
        ProductCompoundData.delete(this.props.id, (res) => {
            this.setState({add_loading:false, delete_loading:false});
            if (res === null) {
                this.props.removeCombo(this.props.id);
            } else {
                this.props.showToast({
                    show:true,
                    type:'error',
                    message:'Tenemos un problema!'
                });
            }
        });
    };

    handleCanExcluded = () => {
        this.update({
            id:this.props.id,
            can_excluded: !this.state.can_excluded
        });
        this.setState({'can_excluded': !this.state.can_excluded});
    };

    render() {
        return (
            <List.Item>
                <List.Content floated='left'>
                    <Button.Group size='small'>
                        <Button
                            icon='minus'
                            onClick={this.handleDelete}
                            loading={this.state.delete_loading}
                            disabled={this.state.delete_loading}/>
                        <Button content={this.state.quantity} active />
                        <Button
                            icon='plus'
                            onClick={this.handleAdd}
                            loading={this.state.add_loading}
                            disabled={this.state.add_loading}/>
                    </Button.Group>
                </List.Content>
                <List.Content floated='right'>
                    <Popup
                        content='Permitir seleccionar ingredientes y/o recetas del producto'
                        trigger={<Checkbox toggle label={`${this.state.can_excluded ? 'Si':"No"} Opcional`} checked={this.state.can_excluded} onChange={this.handleCanExcluded} style={{marginRight:'0.3em'}}/>}
                    />
                    <Button.Group size='small' color='orange'>
                        <Button
                            icon='trash'
                            onClick={this.handleRemove}
                            loading={this.state.remove_loading}
                            disabled={this.state.remove_loading}/>
                    </Button.Group>
                </List.Content>
                <List.Content style={{paddingTop:10}}>{this.props.recipe ? 'Receta':'Ingrediente'}: {this.props.recipe ? this.props.recipe.name:this.props.ingredient.name}</List.Content>
            </List.Item>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        showToast(data) {
            dispatch(showToast(data));
        },
        removeCombo(id){
            dispatch(removeCombo(id))
        }
    }
}

export default connect(
    null,
    mapDispatchToProps
)(ProductRecipeItem);



// WEBPACK FOOTER //
// ./src/components/inventories/ProductRecipeItem.js